module.exports = __webpack_public_path__ + "img/IMG_1837.09434672.jpg";